// Lista de países en español para los selects de "País" del módulo SBTi
// (Paso1Inventario · desglose por sitio, Dashboard · país sede de la
// empresa) — antes eran inputs de texto libre sin ninguna ayuda. No existía
// una lista de países en ningún otro lugar de la app para reusar.
export const COUNTRIES = [
  "Argentina", "Bolivia", "Brasil", "Chile", "Colombia", "Costa Rica", "Cuba",
  "Ecuador", "El Salvador", "Guatemala", "Honduras", "México", "Nicaragua",
  "Panamá", "Paraguay", "Perú", "República Dominicana", "Uruguay", "Venezuela",
  "Estados Unidos", "Canadá",
  "España", "Portugal", "Francia", "Italia", "Alemania", "Reino Unido",
  "Irlanda", "Países Bajos", "Bélgica", "Suiza", "Austria", "Suecia",
  "Noruega", "Dinamarca", "Finlandia", "Polonia", "República Checa",
  "Hungría", "Rumania", "Bulgaria", "Grecia", "Turquía", "Ucrania",
  "China", "India", "Indonesia", "Vietnam", "Bangladés", "Pakistán",
  "Camboya", "Tailandia", "Filipinas", "Malasia", "Sri Lanka", "Japón",
  "Corea del Sur", "Taiwán", "Hong Kong",
  "Marruecos", "Túnez", "Egipto", "Sudáfrica", "Etiopía", "Kenia",
  "Nigeria", "Ghana", "Madagascar",
  "Australia", "Nueva Zelanda",
].sort((a, b) => a.localeCompare(b, "es"));

export const COUNTRY_OPTIONS = COUNTRIES.map((name) => ({ key: name, value: name, text: name }));

// Para un Select con `search allowAdditions`: agrega temporalmente el valor
// ya guardado si no está en la lista base (país tipeado a mano en un
// registro viejo, o no incluido en COUNTRIES), para que el select lo pueda
// mostrar seleccionado en vez de aparecer vacío.
export function countryOptionsWithCurrent(value) {
  if (!value || COUNTRIES.includes(value)) return COUNTRY_OPTIONS;
  return [{ key: value, value, text: value }, ...COUNTRY_OPTIONS];
}
